export * from './abstract-auth.provider';
export * from './email-pass-auth.provider';



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@nebular/auth/providers/index.ts